export default "__VITE_ASSET__adfa89c2__"